<style scoped>
.addMargin {
  margin-top: 10px;
}
.grayOut {
  /* background: #f2f2f2; */
  color: rgb(170, 170, 170);
}
.ivu-avatar-large.ivu-avatar-icon {
  border-radius: 0;
}

.resource-container {
  display: flex;
  padding: 10px;
  background: #fff;
  border-bottom: 1px solid #eee;
  align-items: center;
  cursor: pointer;
}

.resource-avatar {
  margin-right: 10px;
  height: 40px;
  width: 40px;
}

.resource-body {
  height: 40px;
  overflow: hidden;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.resource-content > h3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.resource-content {
  overflow: hidden;
  margin-right: 30px;
}

.large-image {
  height: 40px;
  width: 40px;
}
</style>

<template>
  <div>
    <Row type="flex" justify="center">
      <i-col :span="24">
        <div class="resource-container"  v-on:click="goTo(item)">
          <div class="resource-avatar">
            <img v-bind:src='item.icon' class="large-image" />
          </div>
          <div class="resource-body">
            <div class="resource-content">
                <h3>{{item.title}}</h3>
            </div>
          </div>
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>

export default {
  name: 'MenuListComponent',
    data () {
    return {

    }
  },
  props: {
    item: {
      required: true
    }
  },
  computed:{
    getIcon: {
      get() {
        return '@/' + this.item.icon
      }
    }
  },
  mounted() {
  },
  methods: {
    goTo(v){
        this.$router.push({
            path: v.link, query:{id:this.item.id, type:this.item.type, section:this.item.title}
        })
    }
  },
}
</script>
